module.exports = __webpack_public_path__ + "img/car_00049.413159d0.jpg";